$dubai-default: #000C37;
$future-default: #0088FF;
$storm: #9EA9B9;

.pagination-box {
  display: flex;
  justify-content: end;
}

.pagination {
  display: flex;
  align-items: center;
  justify-content: space-between;
  max-width: 300px;
  width: 100%;
  margin: 10px 0;

  &__page {
    padding: 5px;
    font-size: 12px;
    user-select: none;
    font-weight: 500;
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 6px;
    transition: background .2s linear;

    &:hover {
      cursor: pointer;
      background: rgba($dubai-default, .1);
    }

    &.isActive {
      background: $dubai-default;
      color: #ffffff !important;
    }
  }

  &__navbtn {
    user-select: none;
    padding: 10px 15px;
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: center;

    svg {
      path {
        stroke: $dubai-default;
        transition: all .2s linear;
      }
    }

    &:hover {
      cursor: pointer;

      svg {
        path {
          stroke: $future-default;
        }
      }
    }

    &.disabled {
      user-select: none;
      cursor: not-allowed;

      svg {
        path {
          stroke: $storm;
        }
      }
    }

    &.left {
      transform: rotate(180deg);
    }
  }
}
